import CircularProgress from '@material-ui/core/CircularProgress';
import { getAuth } from "firebase/auth";
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
    BrowserRouter as Router, Route, Switch
} from "react-router-dom";
import './App.css';
import NavBar from './components/NavBar';
import routes from './routes/routes';
import Home from './screens/Home';
import Login from './screens/Login';
import TellMeWatch from './screens/Tell_Me_Watch';
import TellMeHome from './screens/Tell_Me';
import { getDataSetToRedux } from './utility/getAffirmationAndCategory';

function AppNav() {

    const auth = getAuth();
    const dispatch = useDispatch();
    const [authenticated, setAuth] = useState(false);
    const [initializing, setInitiliazing] = useState(true);


    // Handle Auth Changes
    async function onAuthStateChanged(user: any) {
        console.log("AUTH CHANGED");
        if (user) {
            setAuth(true);
            await getDataSetToRedux(dispatch);
        } else {
            setAuth(false);
        }

        if (initializing) setInitiliazing(false);
    }


    // Listen Auth Changes
    useEffect(() => {
        const subscriber = auth.onAuthStateChanged(onAuthStateChanged)
        return subscriber;
    }, [])



    // If initiliazing show circular progress
    if (initializing) {
        return (
            <div style={{ margin: 25 }}>
                <CircularProgress />
            </div>
        );
    }

    return (
        <div>

            <Router>
                {
                    authenticated ?
                        <>
                            <NavBar />
                            <Switch>
                                <Route exact path={routes.tellMeWatchRouteName}>
                                    <TellMeWatch />
                                </Route>

                                <Route exact path={routes.tellMeHomeRouteName}>
                                    <TellMeHome />
                                </Route>

                                <Route exact path={routes.homeRouteName}>
                                    <Home />
                                </Route>
                                <Route component={() => <h2>Error 404, Page Not Found!</h2>} />
                            </Switch>
                        </>
                        :
                        <Switch>
                            <Route component={() => <Login />}/>
                        </Switch>

                }
            </Router>
        </div>
    )
}
export default AppNav;

